import { useState, useEffect, useCallback, useRef } from "react";
import { useApiError } from "./useApiError";
import { BitmakerAPIClient } from "../services/BitmakerApp";
import {
  SprintUserTimeOffEntry,
  SprintUserTimeOffEntryFromJSON,
} from "../bitmaker/schemas/Sprints/SprintUserTimeOffEntry";

export const useSprintUserTimeOff = (login?: string, sprintId?: string) => {
  const [entries, setEntries] = useState<SprintUserTimeOffEntry[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const { handleAPIError } = useApiError();
  const isMountedRef = useRef(false);

  useEffect(() => {
    isMountedRef.current = true;
    return () => {
      isMountedRef.current = false;
    };
  }, []);

  const fetchTimeOff = useCallback(() => {
    if (!isMountedRef.current || !login) return;

    setLoading(true);
    setError(null);

    const url = sprintId
      ? `/sprints/${sprintId}/users/${login}/time-off`
      : `/sprints/current/users/${login}/time-off`;

    BitmakerAPIClient.get(url, null, (response) => {
      if (!isMountedRef.current) return;

      const { isError, message } = handleAPIError(response);

      if (isError) {
        console.error("Error fetching sprint user time off:", message);
        setError("Error loading time off. Please try again.");
        setLoading(false);
        return;
      }

      const data = Array.isArray(response.data) ? response.data : [];
      setEntries(data.map(SprintUserTimeOffEntryFromJSON));
      setLoading(false);
    });
  }, [login, sprintId, handleAPIError]);

  useEffect(() => {
    fetchTimeOff();
  }, [fetchTimeOff]);

  return {
    timeOffEntries: entries,
    loadingTimeOff: loading,
    fetchTimeOffError: error,
    refetchTimeOff: fetchTimeOff,
  };
};
